var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 135,
    viewBox: "0 0 129 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 6.00015C29 6.00015 76 5.99981 95 6.00015C114 6.00049 128.5 28.0002 128.5 39.0002C128.5 50.0002 128.5 79.5005 128.5 102C128.5 124.5 99.5 134.5 93 134.5C86.5 134.5 41.5 134.5 32.5 134.5C23.5 134.5 0 122.5 0 102C0 81.5005 0 60.5002 0 39.0002C0 17.5002 25.5 6.00015 29 6.00015V16.0002C26.5 16.0005 11 26.5005 11 39.0002C11 51.4998 11 93.9998 11 102C11 110 23.5 123.5 31.5 123.5C39.5 123.5 84.5 123.5 93 123.5C101.5 123.5 117.5 110 117.5 102C117.5 94.0005 117.5 41.0005 117.5 39.0002C117.5 36.9998 107.5 18.0005 97 17.5002C86.5 16.9998 29 16.0002 29 16.0002V6.00015Z",
    fill: "#0063FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 31,
    width: 27,
    height: 24,
    fill: "#0063FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 91,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 61,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 61,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 61,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 31,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 31,
    width: 27,
    height: 24,
    fill: "#7DB0FF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    width: 18,
    height: 12,
    fill: "#0063FF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83,
    width: 18,
    height: 12,
    fill: "#0063FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.91499d631c93b8c9aaa5fc66da7a4c9c.svg";
export { ForwardRef as ReactComponent };